var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 151,
    viewBox: "0 0 152 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 150,
    height: 150
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.5H134C142.56 1.5 149.5 8.43959 149.5 17V135C149.5 143.56 142.56 150.5 134 150.5H16C7.43959 150.5 0.5 143.56 0.5 135V17C0.500001 8.43959 7.43959 1.5 16 1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.5H134C142.56 1.5 149.5 8.43959 149.5 17V135C149.5 143.56 142.56 150.5 134 150.5H16C7.43959 150.5 0.5 143.56 0.5 135V17C0.500001 8.43959 7.43959 1.5 16 1.5Z",
    stroke: "#EBEBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.387 -139.5H353.056C361.008 -139.5 365.921 -130.827 361.834 -124.006L252.601 58.3086C248.813 64.6307 241.983 68.5 234.613 68.5H74.9443C66.9925 68.4998 62.079 59.8271 66.166 53.0059L175.399 -129.309C179.187 -135.631 186.017 -139.5 193.387 -139.5Z",
    stroke: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.387 -78.5H391.056C399.008 -78.4998 403.921 -69.8272 399.834 -63.0059L290.601 119.309C286.813 125.631 279.983 129.5 272.613 129.5H112.944C104.992 129.5 100.079 120.827 104.166 114.006L213.399 -68.3086C217.187 -74.6307 224.017 -78.5 231.387 -78.5Z",
    stroke: "#EBEBEB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryCardBg);
export default __webpack_public_path__ + "static/media/categoryCard_bg.10469da3593170b3baa62d9e211cb83e.svg";
export { ForwardRef as ReactComponent };